export default __webpack_public_path__ + "static/media/NMS.1f5a3615.png";